import { create } from "zustand";
import { adSpends as seed } from "@/mocks/seed";
import type { AdSpend } from "@/types";

/** Mock store for ad-spend when unauthenticated / API down (Phase 5.2). */
interface AdSpendState {
  active: AdSpend[];
  archived: AdSpend[];
  add: (entry: AdSpend) => void;
  archive: (id: string) => void;
  restore: (id: string) => void;
}

export const useAdSpendStore = create<AdSpendState>((set) => ({
  active: seed,
  archived: [],
  add: (entry) => set((s) => ({ active: [entry, ...s.active] })),
  archive: (id) =>
    set((s) => {
      const target = s.active.find((a) => a.id === id);
      if (!target) return s;
      return { active: s.active.filter((a) => a.id !== id), archived: [target, ...s.archived] };
    }),
  restore: (id) =>
    set((s) => {
      const target = s.archived.find((a) => a.id === id);
      if (!target) return s;
      return { archived: s.archived.filter((a) => a.id !== id), active: [target, ...s.active] };
    }),
}));
